import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { queryFnFactory, settlementEligibilityCacheKey } from '@syf-api-library/settlement-eligibility';
import { apiConfigAtom } from './accountActivity';
export const settlementEligibilityAtom = atomWithQuery((get) => {
    const apiConfig = get(apiConfigAtom);
    return {
        queryKey: settlementEligibilityCacheKey(apiConfig.keyProps),
        queryFn: queryFnFactory(apiConfig.config, apiConfig.keyProps),
        queryOptions: Object.assign({}, apiConfig.queryOptions)
    };
});
export const useSettlementEligibility = () => {
    return useAtom(settlementEligibilityAtom);
};
